import request from '../utils/request';
/**
 * @description: 产品详情
 * @param {*} data 
 */
export function getProductDetail(data) {
  return request({
    url: '/api/weixin/getProductDetail',
    method: 'post',
    params:data
  })
}

/**
 * @description: 颜色
 * @param {*} data 
 */
 export function getProductColorDetailByID(data) {
  return request({
    url: '/TLForLDZApp/GetProductColorDetailByID',
    method: 'post',
    params:data
  })
}